export const EventRecurrence = {
	PUNCTUAL: "punctual",
	WEEKLY: "weekly",
	MONTHLY: "monthly",
} as const;
export type EventRecurrence = (typeof EventRecurrence)[keyof typeof EventRecurrence];

export const EventFormat = {
	ONLINE: "online",
	IN_PERSON: "in_person",
	HYBRID: "hybrid",
} as const;
export type EventFormat = (typeof EventFormat)[keyof typeof EventFormat];

export const EventStatus = {
	PUBLISHED: "published",
	CANCELLED: "cancelled",
} as const;
export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus];

export const EventAttendeeStatus = {
	PENDING: "pending",
	REGISTERED: "registered",
	DECLINED: "declined",
	WAITLISTED: "waitlisted",
} as const;
export type EventAttendeeStatus = (typeof EventAttendeeStatus)[keyof typeof EventAttendeeStatus];

export const EventAudience = {
	ENTIRE: "entire",
	GROUPS: "groups",
	MEMBERS: "members",
} as const;
export type EventAudience = (typeof EventAudience)[keyof typeof EventAudience];

export const EventAudienceFilter = {
	ALL: "all",
	REGISTERED: "registered",
} as const;
export type EventAudienceFilter = (typeof EventAudienceFilter)[keyof typeof EventAudienceFilter];

export const EventTimeFilter = {
	UPCOMING: "upcoming",
	PAST: "past",
} as const;
export type EventTimeFilter = (typeof EventTimeFilter)[keyof typeof EventTimeFilter];

export const EventVisibility = {
	PUBLIC: "public",
	PRIVATE: "private",
} as const;
export type EventVisibility = (typeof EventVisibility)[keyof typeof EventVisibility];

export const EventExternalGuestStatus = {
	PENDING: "pending",
	ACCEPTED: "accepted",
	DECLINED: "declined",
} as const;
export type EventExternalGuestStatus = (typeof EventExternalGuestStatus)[keyof typeof EventExternalGuestStatus];
